import React from 'react';
import { Sparkles, Heart, Globe } from 'lucide-react';

const About = ({ artistData }) => {
  if (!artistData) return null;
  
  const bioParagraphs = artistData.bio.split('\n\n');

  return (
    <section id="about" className="py-24 px-6 relative overflow-hidden bg-black">
      {/* Background sacred geometry */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/3 right-1/4 w-96 h-96">
          <svg viewBox="0 0 200 200" className="w-full h-full">
            <circle cx="100" cy="100" r="80" fill="none" stroke="#D4AF37" strokeWidth="0.5"/>
            <circle cx="100" cy="100" r="60" fill="none" stroke="#D4AF37" strokeWidth="0.5"/>
            <circle cx="100" cy="100" r="40" fill="none" stroke="#D4AF37" strokeWidth="0.5"/>
          </svg>
        </div>
      </div>
      
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 mb-6">
            <Sparkles className="w-4 h-4 text-[#D4AF37]" />
            <span className="text-sm font-medium text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>Origin Story</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-bold mb-6 text-white" style={{ fontFamily: 'Cinzel, serif' }}>
            The Journey
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Bio Image */}
          <div className="relative">
            <div className="relative aspect-[4/5] overflow-hidden">
              {/* Gold border frame */}
              <div className="absolute inset-0 border-2 border-[#D4AF37]/30"></div>
              <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-[#D4AF37]"></div>
              <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-[#D4AF37]"></div>
              <div className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-[#D4AF37]"></div>
              <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-[#D4AF37]"></div>
              
              <div className="absolute inset-2 overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/30641685/pexels-photo-30641685.jpeg"
                  alt="Piano in golden light"
                  className="w-full h-full object-cover opacity-80"
                />
              </div>
            </div>
            
            {/* Floating info card */}
            <div className="absolute -bottom-6 -right-6 bg-black border-2 border-[#D4AF37] p-6 max-w-xs">
              <div className="flex items-center space-x-3 mb-2">
                <Globe className="w-5 h-5 text-[#D4AF37]" />
                <span className="text-sm font-semibold text-white">Heritage</span>
              </div>
              <p className="text-xs text-gray-400">
                German-Scandinavian & Filipino-Spanish
              </p>
            </div>
          </div>
          
          {/* Bio Text */}
          <div className="space-y-6">
            {bioParagraphs.map((paragraph, index) => (
              <p key={index} className="text-lg text-gray-300 leading-relaxed">
                {paragraph}
              </p>
            ))}
            
            <div className="pt-6 mt-6 border-t border-[#D4AF37]/20">
              <div className="flex items-start space-x-3 p-4 bg-[#D4AF37]/5 border-l-4 border-[#D4AF37]">
                <Heart className="w-5 h-5 text-[#D4AF37] mt-1 flex-shrink-0" />
                <p className="text-base italic text-gray-400">
                  {artistData.quote}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;